import { sub, format } from "date-fns";

// Mock data store for the entire application
class MockDataStore {
  constructor() {
    const now = new Date();

    // Define dates for unavailability
    const unavailableDate1 = new Date();
    unavailableDate1.setDate(unavailableDate1.getDate() + 5);
    unavailableDate1.setHours(9, 0, 0, 0); // 9 AM

    const unavailableDate1End = new Date(unavailableDate1);
    unavailableDate1End.setHours(12, 0, 0, 0); // 12 PM

    const unavailableDate2 = new Date();
    unavailableDate2.setDate(unavailableDate2.getDate() + 10);
    unavailableDate2.setHours(0, 0, 0, 0); // Start of the day for all-day event

    const unavailableDate2End = new Date();
    unavailableDate2End.setDate(unavailableDate2End.getDate() + 11);
    unavailableDate2End.setHours(0, 0, 0, 0); // Start of the next day for all-day event

    this.data = {
      bloodTests: [
        {
          id: "bt1",
          patient_id: "PAT001",
          test_date: format(sub(now, { months: 5 }), "yyyy-MM-dd"),
          test_type: "complete_blood_count",
          lab_name: "LabCorp",
          doctor_name: "Dr. Smith",
          results: {
            glucose: 95,
            hemoglobin: 14.2,
            white_blood_cells: 6500,
            cholesterol_total: 185,
            cholesterol_hdl: 45,
            cholesterol_ldl: 110,
            triglycerides: 150,
          },
          notes: "Normal results",
          created_date:
            format(sub(now, { months: 5 }), "yyyy-MM-dd") + "T10:00:00Z",
          created_by: "system@example.com",
        },
        {
          id: "bt2",
          patient_id: "PAT001",
          test_date: format(sub(now, { months: 4 }), "yyyy-MM-dd"),
          test_type: "lipid_panel",
          lab_name: "Quest",
          doctor_name: "Dr. Johnson",
          results: {
            glucose: 88,
            hemoglobin: 14.5,
            white_blood_cells: 6200,
            cholesterol_total: 175,
            cholesterol_hdl: 50,
            cholesterol_ldl: 105,
            triglycerides: 140,
          },
          notes: "Improved lipid profile",
          created_date:
            format(sub(now, { months: 4 }), "yyyy-MM-dd") + "T09:30:00Z",
          created_by: "system@example.com",
        },
        {
          id: "bt3",
          patient_id: "PAT002",
          test_date: format(sub(now, { months: 4 }), "yyyy-MM-dd"),
          test_type: "basic_metabolic_panel",
          lab_name: "LabCorp",
          doctor_name: "Dr. Williams",
          results: {
            glucose: 102,
            hemoglobin: 13.8,
            white_blood_cells: 7100,
            cholesterol_total: 220,
            cholesterol_hdl: 38,
            cholesterol_ldl: 145,
            triglycerides: 185,
          },
          notes: "Slightly elevated glucose",
          created_date:
            format(sub(now, { months: 4 }), "yyyy-MM-dd") + "T11:15:00Z",
          created_by: "system@example.com",
        },
        {
          id: "bt4",
          patient_id: "PAT001",
          test_date: format(sub(now, { months: 3 }), "yyyy-MM-dd"),
          test_type: "complete_blood_count",
          lab_name: "LabCorp",
          doctor_name: "Dr. Smith",
          results: {
            glucose: 92,
            hemoglobin: 14.8,
            white_blood_cells: 7000,
            cholesterol_total: 180,
            cholesterol_hdl: 48,
            cholesterol_ldl: 102,
            triglycerides: 155,
          },
          notes: "Stable results",
          created_date:
            format(sub(now, { months: 3 }), "yyyy-MM-dd") + "T10:00:00Z",
          created_by: "system@example.com",
        },
        {
          id: "bt5",
          patient_id: "PAT001",
          test_date: format(sub(now, { months: 2 }), "yyyy-MM-dd"),
          test_type: "lipid_panel",
          lab_name: "Quest",
          doctor_name: "Dr. Johnson",
          results: {
            glucose: 90,
            hemoglobin: 14.6,
            white_blood_cells: 6800,
            cholesterol_total: 170,
            cholesterol_hdl: 52,
            cholesterol_ldl: 98,
            triglycerides: 130,
          },
          notes: "Lipid profile continues to improve.",
          created_date:
            format(sub(now, { months: 2 }), "yyyy-MM-dd") + "T09:30:00Z",
          created_by: "system@example.com",
        },
        {
          id: "bt6",
          patient_id: "PAT001",
          test_date: format(sub(now, { months: 1 }), "yyyy-MM-dd"),
          test_type: "basic_metabolic_panel",
          lab_name: "LabCorp",
          doctor_name: "Dr. Smith",
          results: {
            glucose: 89,
            hemoglobin: 14.7,
            white_blood_cells: 6500,
            cholesterol_total: 172,
            cholesterol_hdl: 51,
            cholesterol_ldl: 100,
            triglycerides: 135,
          },
          notes: "Excellent results.",
          created_date:
            format(sub(now, { months: 1 }), "yyyy-MM-dd") + "T11:00:00Z",
          created_by: "system@example.com",
        },
        {
          id: "bt7",
          patient_id: "PAT001",
          test_date: format(sub(now, { days: 15 }), "yyyy-MM-dd"),
          test_type: "complete_blood_count",
          lab_name: "LabCorp",
          doctor_name: "Dr. Smith",
          results: {
            glucose: 87,
            hemoglobin: 14.9,
            white_blood_cells: 6300,
            cholesterol_total: 168,
            cholesterol_hdl: 53,
            cholesterol_ldl: 95,
            triglycerides: 125,
          },
          notes: "Continued improvement in all markers.",
          created_date:
            format(sub(now, { days: 15 }), "yyyy-MM-dd") + "T10:30:00Z",
          created_by: "system@example.com",
        },
        {
          id: "bt8",
          patient_id: "PAT002",
          test_date: format(sub(now, { months: 3 }), "yyyy-MM-dd"),
          test_type: "complete_blood_count",
          lab_name: "Quest",
          doctor_name: "Dr. Williams",
          results: {
            glucose: 108,
            hemoglobin: 13.2,
            white_blood_cells: 7800,
            cholesterol_total: 240,
            cholesterol_hdl: 35,
            cholesterol_ldl: 155,
            triglycerides: 200,
          },
          notes: "Elevated glucose and cholesterol levels.",
          created_date:
            format(sub(now, { months: 3 }), "yyyy-MM-dd") + "T09:00:00Z",
          created_by: "system@example.com",
        },
        {
          id: "bt9",
          patient_id: "PAT002",
          test_date: format(sub(now, { months: 2 }), "yyyy-MM-dd"),
          test_type: "lipid_panel",
          lab_name: "Quest",
          doctor_name: "Dr. Williams",
          results: {
            glucose: 104,
            hemoglobin: 13.5,
            white_blood_cells: 7400,
            cholesterol_total: 225,
            cholesterol_hdl: 38,
            cholesterol_ldl: 148,
            triglycerides: 185,
          },
          notes: "Slight improvement in lipid profile.",
          created_date:
            format(sub(now, { months: 2 }), "yyyy-MM-dd") + "T10:15:00Z",
          created_by: "system@example.com",
        },
        {
          id: "bt10",
          patient_id: "PAT002",
          test_date: format(sub(now, { months: 1 }), "yyyy-MM-dd"),
          test_type: "basic_metabolic_panel",
          lab_name: "LabCorp",
          doctor_name: "Dr. Williams",
          results: {
            glucose: 98,
            hemoglobin: 13.8,
            white_blood_cells: 7000,
            cholesterol_total: 210,
            cholesterol_hdl: 42,
            cholesterol_ldl: 135,
            triglycerides: 165,
          },
          notes: "Continued progress toward target levels.",
          created_date:
            format(sub(now, { months: 1 }), "yyyy-MM-dd") + "T11:30:00Z",
          created_by: "system@example.com",
        },
        {
          id: "bt11",
          patient_id: "PAT002",
          test_date: format(sub(now, { days: 20 }), "yyyy-MM-dd"),
          test_type: "complete_blood_count",
          lab_name: "Quest",
          doctor_name: "Dr. Williams",
          results: {
            glucose: 92,
            hemoglobin: 14.0,
            white_blood_cells: 6800,
            cholesterol_total: 195,
            cholesterol_hdl: 45,
            cholesterol_ldl: 125,
            triglycerides: 150,
          },
          notes: "Excellent progress - approaching optimal levels.",
          created_date:
            format(sub(now, { days: 20 }), "yyyy-MM-dd") + "T08:45:00Z",
          created_by: "system@example.com",
        },
        {
          id: "bt12",
          patient_id: "PAT003",
          test_date: format(sub(now, { months: 2 }), "yyyy-MM-dd"),
          test_type: "complete_blood_count",
          lab_name: "LabCorp",
          doctor_name: "Dr. Johnson",
          results: {
            glucose: 85,
            hemoglobin: 15.2,
            white_blood_cells: 5800,
            cholesterol_total: 165,
            cholesterol_hdl: 58,
            cholesterol_ldl: 88,
            triglycerides: 95,
          },
          notes: "Excellent baseline values for new patient.",
          created_date:
            format(sub(now, { months: 2 }), "yyyy-MM-dd") + "T14:20:00Z",
          created_by: "system@example.com",
        },
        {
          id: "bt13",
          patient_id: "PAT003",
          test_date: format(sub(now, { months: 1 }), "yyyy-MM-dd"),
          test_type: "lipid_panel",
          lab_name: "Quest",
          doctor_name: "Dr. Johnson",
          results: {
            glucose: 82,
            hemoglobin: 15.4,
            white_blood_cells: 5600,
            cholesterol_total: 158,
            cholesterol_hdl: 62,
            cholesterol_ldl: 82,
            triglycerides: 88,
          },
          notes: "Outstanding results - maintaining optimal health.",
          created_date:
            format(sub(now, { months: 1 }), "yyyy-MM-dd") + "T13:10:00Z",
          created_by: "system@example.com",
        },
        {
          id: "bt14",
          patient_id: "PAT003",
          test_date: format(sub(now, { days: 10 }), "yyyy-MM-dd"),
          test_type: "complete_blood_count",
          lab_name: "LabCorp",
          doctor_name: "Dr. Johnson",
          results: {
            glucose: 80,
            hemoglobin: 15.6,
            white_blood_cells: 5500,
            cholesterol_total: 152,
            cholesterol_hdl: 65,
            cholesterol_ldl: 78,
            triglycerides: 82,
          },
          notes: "Exceptional health markers - continue current regimen.",
          created_date:
            format(sub(now, { days: 10 }), "yyyy-MM-dd") + "T12:00:00Z",
          created_by: "system@example.com",
        },
      ],
      clinicalNotes: [
        {
          id: "cn1",
          patient_id: "PAT001",
          visit_date: format(sub(now, { months: 5 }), "yyyy-MM-dd"),
          chief_complaint: "Annual physical exam",
          assessment:
            "Patient appears healthy, vital signs normal. Blood pressure slightly elevated.",
          plan: "Continue current medications, follow-up in 3 months",
          vital_signs: {
            blood_pressure_systolic: 130,
            blood_pressure_diastolic: 85,
            heart_rate: 72,
            temperature: 98.6,
            weight: 175,
            height: 70,
          },
          medications: [
            { name: "Lisinopril", dosage: "10mg", frequency: "Daily" },
            { name: "Metformin", dosage: "500mg", frequency: "Twice daily" },
          ],
          follow_up: "3 months",
          doctor_name: "Dr. Smith",
          created_date:
            format(sub(now, { months: 5 }), "yyyy-MM-dd") + "T10:00:00Z",
          created_by: "dr.smith@example.com",
        },
        {
          id: "cn2",
          patient_id: "PAT002",
          visit_date: format(sub(now, { months: 4 }), "yyyy-MM-dd"),
          chief_complaint: "Chest pain and shortness of breath",
          assessment:
            "Mild chest discomfort, likely related to stress. EKG normal.",
          plan: "Stress management techniques, follow-up if symptoms persist",
          vital_signs: {
            blood_pressure_systolic: 140,
            blood_pressure_diastolic: 90,
            heart_rate: 85,
            temperature: 98.4,
            weight: 180,
            height: 68,
          },
          medications: [
            { name: "Aspirin", dosage: "81mg", frequency: "Daily" },
          ],
          follow_up: "2 weeks PRN",
          doctor_name: "Dr. Williams",
          created_date:
            format(sub(now, { months: 4 }), "yyyy-MM-dd") + "T11:15:00Z",
          created_by: "dr.williams@example.com",
        },
      ],
      prescriptions: [
        {
          id: "pr1",
          patient_id: "PAT001",
          prescribing_doctor: "Dr. Smith",
          prescription_date: "2024-01-15",
          prescribed_items: [
            {
              item_type: "medication",
              item_id: "si1",
              item_name: "Lisinopril 10mg",
              quantity: 30,
              dosage: "10mg",
              frequency: "Once daily",
              duration: "30 days",
              cost_per_unit: 1.5,
              total_cost: 45.0,
              status: "dispensed",
            },
          ],
          total_prescription_cost: 45.0,
          status: "active",
          created_date: "2024-01-15T10:00:00Z",
          created_by: "dr.smith@example.com",
        },
      ],
      stockItems: [
        {
          id: "si1",
          item_name: "Lisinopril 10mg",
          item_code: "LIS-10",
          category: "medication",
          description: "ACE inhibitor for hypertension",
          manufacturer: "Generic Pharma",
          strength: "10mg",
          dosage_form: "tablet",
          unit_of_measure: "tablets",
          current_stock: 500,
          minimum_stock: 50,
          reorder_point: 100,
          cost_per_unit: 1.5,
          selling_price: 2.25,
          status: "active",
          created_date: "2024-01-01T00:00:00Z",
          created_by: "admin@example.com",
        },
        {
          id: "si2",
          item_name: "Metformin 500mg",
          item_code: "MET-500",
          category: "medication",
          description: "Diabetes medication",
          manufacturer: "Generic Pharma",
          strength: "500mg",
          dosage_form: "tablet",
          unit_of_measure: "tablets",
          current_stock: 25,
          minimum_stock: 50,
          reorder_point: 100,
          cost_per_unit: 0.75,
          selling_price: 1.5,
          status: "low_stock",
          created_date: "2024-01-01T00:00:00Z",
          created_by: "admin@example.com",
        },
      ],
      stockTransactions: [
        {
          id: "st1",
          stock_item_id: "si1",
          transaction_type: "dispense",
          quantity: 30,
          transaction_date: "2024-01-15",
          reference_number: "pr1",
          patient_id: "PAT001",
        },
      ],
      services: [
        {
          id: "sv1",
          service_name: "IV Vitamin C Therapy",
          service_code: "IVC-001",
          category: "iv_therapy",
          description: "High-dose vitamin C infusion",
          duration_minutes: 60,
          base_price: 150.0,
          status: "active",
          created_date: "2024-01-01T00:00:00Z",
          created_by: "admin@example.com",
        },
        {
          id: "sv2",
          service_name: "Comprehensive Health Consultation",
          service_code: "CHC-001",
          category: "consultation",
          description: "In-depth health review and planning session",
          duration_minutes: 90,
          base_price: 350.0,
          status: "active",
          created_date: "2024-01-01T00:00:00Z",
          created_by: "admin@example.com",
        },
      ],
      serviceAppointments: [
        {
          id: "sa1",
          patient_id: "PAT001",
          service_id: "sv1",
          appointment_date: new Date().toISOString(),
          duration_actual: 60,
          provider_name: "Dr. Johnson",
          status: "scheduled",
          notes: "First IV therapy session.",
        },
        {
          id: "sa2",
          patient_id: "PAT002",
          service_id: "sv2",
          appointment_date: sub(new Date(), { days: 1 }).toISOString(),
          duration_actual: 85,
          provider_name: "Dr. Williams",
          status: "completed",
          notes: "Initial consultation, established long-term plan.",
        },
        {
          id: "sa3",
          patient_id: "PAT001",
          service_id: "sv1",
          appointment_date: new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().replace(/T.*/, 'T09:00:00.000Z'),
          duration_actual: 60,
          provider_name: "Dr. Smith",
          status: "scheduled",
          notes: "Follow-up IV vitamin C therapy.",
        },
        {
          id: "sa4",
          patient_id: "PAT003",
          service_id: "sv2",
          appointment_date: new Date(new Date().setDate(new Date().getDate() + 2)).toISOString().replace(/T.*/, 'T10:30:00.000Z'),
          duration_actual: 90,
          provider_name: "Dr. Johnson",
          status: "scheduled",
          notes: "Comprehensive health assessment for new patient.",
        },
        {
          id: "sa5",
          patient_id: "PAT002",
          service_id: "sv1",
          appointment_date: new Date(new Date().setDate(new Date().getDate() + 3)).toISOString().replace(/T.*/, 'T14:00:00.000Z'),
          duration_actual: 60,
          provider_name: "Dr. Williams",
          status: "scheduled",
          notes: "Monthly IV therapy maintenance.",
        },
        {
          id: "sa6",
          patient_id: "PAT001",
          service_id: "sv2",
          appointment_date: new Date(new Date().setDate(new Date().getDate() + 5)).toISOString().replace(/T.*/, 'T11:00:00.000Z'),
          duration_actual: 90,
          provider_name: "Dr. Smith",
          status: "scheduled",
          notes: "Quarterly comprehensive health review.",
        },
        {
          id: "sa7",
          patient_id: "PAT003",
          service_id: "sv1",
          appointment_date: new Date(new Date().setDate(new Date().getDate() + 7)).toISOString().replace(/T.*/, 'T15:30:00.000Z'),
          duration_actual: 60,
          provider_name: "Dr. Johnson",
          status: "scheduled",
          notes: "Second IV therapy session.",
        },
        {
          id: "sa8",
          patient_id: "PAT002",
          service_id: "sv2",
          appointment_date: new Date(new Date().setDate(new Date().getDate() - 3)).toISOString().replace(/T.*/, 'T13:00:00.000Z'),
          duration_actual: 85,
          provider_name: "Dr. Williams",
          status: "completed",
          notes: "Completed consultation - prescribed new supplement regimen.",
        },
        {
          id: "sa9",
          patient_id: "PAT001",
          service_id: "sv1",
          appointment_date: new Date(new Date().setDate(new Date().getDate() - 5)).toISOString().replace(/T.*/, 'T16:00:00.000Z'),
          duration_actual: 65,
          provider_name: "Dr. Smith",
          status: "completed",
          notes: "Completed IV therapy - patient tolerated well.",
        },
        {
          id: "sa10",
          patient_id: "PAT003",
          service_id: "sv2",
          appointment_date: new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().replace(/T.*/, 'T08:30:00.000Z'),
          duration_actual: 95,
          provider_name: "Dr. Johnson",
          status: "completed",
          notes: "Initial consultation completed - baseline established.",
        },
      ],
      unavailability: [
        {
          id: "un1",
          provider_name: "Dr. Johnson",
          start_time: unavailableDate1.toISOString(),
          end_time: unavailableDate1End.toISOString(),
          reason: "Personal Appointment",
          is_all_day: false,
        },
        {
          id: "un2",
          provider_name: "Dr. Williams",
          start_time: unavailableDate2.toISOString(),
          end_time: unavailableDate2End.toISOString(),
          reason: "Conference",
          is_all_day: true,
        },
      ],
      patients: [
        {
          id: "p1",
          patient_id: "PAT001",
          first_name: "John",
          last_name: "Doe",
          full_name: "John Doe",
          email: "john.doe@example.com",
          phone: "555-0123",
          date_of_birth: "1980-05-15",
          gender: "male",
          address: {
            street: "123 Main St",
            city: "Anytown",
            state: "CA",
            zip_code: "12345",
            country: "USA",
          },
          status: "active",
          created_date: "2024-01-01T00:00:00Z",
          created_by: "admin@example.com",
        },
        {
          id: "p2",
          patient_id: "PAT002",
          first_name: "Jane",
          last_name: "Smith",
          full_name: "Jane Smith",
          email: "jane.smith@example.com",
          phone: "555-0124",
          date_of_birth: "1975-08-22",
          gender: "female",
          address: {
            street: "456 Oak Ave",
            city: "Anytown",
            state: "CA",
            zip_code: "12346",
            country: "USA",
          },
          status: "active",
          created_date: "2024-01-01T00:00:00Z",
          created_by: "admin@example.com",
        },
        {
          id: "p3",
          patient_id: "PAT003",
          first_name: "Michael",
          last_name: "Brown",
          full_name: "Michael Brown",
          email: "michael.brown@example.com",
          phone: "555-0125",
          date_of_birth: "1985-03-10",
          gender: "male",
          address: {
            street: "789 Pine St",
            city: "Anytown",
            state: "CA",
            zip_code: "12347",
            country: "USA",
          },
          status: "active",
          created_date: "2024-01-01T00:00:00Z",
          created_by: "admin@example.com",
        },
      ],
      billings: [
        {
          id: "b1",
          patient_id: "PAT001",
          billing_date: format(sub(now, { months: 5 }), "yyyy-MM-dd"),
          service_date: format(sub(now, { months: 5 }), "yyyy-MM-dd"),
          provider_name: "Dr. Smith",
          billing_items: [
            {
              item_type: "consultation",
              description: "Annual Physical Exam",
              quantity: 1,
              unit_price: 200.0,
              total_price: 200.0,
              patient_responsibility: 200.0,
            },
          ],
          subtotal: 200.0,
          total_amount: 200.0,
          patient_total: 200.0,
          payment_status: "paid",
          due_date: format(sub(now, { months: 4 }), "yyyy-MM-dd"),
          created_date:
            format(sub(now, { months: 5 }), "yyyy-MM-dd") + "T10:00:00Z",
          created_by: "dr.smith@example.com",
        },
        {
          id: "b2",
          patient_id: "PAT002",
          billing_date: format(sub(now, { months: 5 }), "yyyy-MM-dd"),
          service_date: format(sub(now, { months: 5 }), "yyyy-MM-dd"),
          provider_name: "Dr. Johnson",
          billing_items: [
            {
              item_type: "service",
              description: "IV Vitamin C Therapy",
              quantity: 1,
              unit_price: 150.0,
              total_price: 150.0,
              patient_responsibility: 150.0,
            },
          ],
          subtotal: 150.0,
          total_amount: 150.0,
          patient_total: 150.0,
          payment_status: "paid",
          due_date: format(sub(now, { months: 4 }), "yyyy-MM-dd"),
          created_date:
            format(sub(now, { months: 5 }), "yyyy-MM-dd") + "T14:00:00Z",
          created_by: "dr.johnson@example.com",
        },
        {
          id: "b3",
          patient_id: "PAT001",
          billing_date: format(sub(now, { months: 4 }), "yyyy-MM-dd"),
          service_date: format(sub(now, { months: 4 }), "yyyy-MM-dd"),
          provider_name: "Dr. Williams",
          billing_items: [
            {
              item_type: "consultation",
              description: "Follow-up Consultation",
              quantity: 1,
              unit_price: 120.0,
              total_price: 120.0,
              patient_responsibility: 120.0,
            },
            {
              item_type: "medication",
              description: "Prescription Medications",
              quantity: 3,
              unit_price: 25.0,
              total_price: 75.0,
              patient_responsibility: 75.0,
            },
          ],
          subtotal: 195.0,
          total_amount: 195.0,
          patient_total: 195.0,
          payment_status: "paid",
          due_date: format(sub(now, { months: 3 }), "yyyy-MM-dd"),
          created_date:
            format(sub(now, { months: 4 }), "yyyy-MM-dd") + "T09:00:00Z",
          created_by: "dr.williams@example.com",
        },
        {
          id: "b4",
          patient_id: "PAT002",
          billing_date: format(sub(now, { months: 4 }), "yyyy-MM-dd"),
          service_date: format(sub(now, { months: 4 }), "yyyy-MM-dd"),
          provider_name: "Dr. Smith",
          billing_items: [
            {
              item_type: "service",
              description: "Blood Filtration Therapy",
              quantity: 1,
              unit_price: 350.0,
              total_price: 350.0,
              patient_responsibility: 350.0,
            },
          ],
          subtotal: 350.0,
          total_amount: 350.0,
          patient_total: 350.0,
          payment_status: "paid",
          due_date: format(sub(now, { months: 3 }), "yyyy-MM-dd"),
          created_date:
            format(sub(now, { months: 4 }), "yyyy-MM-dd") + "T11:30:00Z",
          created_by: "dr.smith@example.com",
        },
        {
          id: "b5",
          patient_id: "PAT001",
          billing_date: format(sub(now, { months: 3 }), "yyyy-MM-dd"),
          service_date: format(sub(now, { months: 3 }), "yyyy-MM-dd"),
          provider_name: "Dr. Johnson",
          billing_items: [
            {
              item_type: "lab_test",
              description: "Comprehensive Blood Panel",
              quantity: 1,
              unit_price: 180.0,
              total_price: 180.0,
              patient_responsibility: 180.0,
            },
            {
              item_type: "consultation",
              description: "Results Review",
              quantity: 1,
              unit_price: 100.0,
              total_price: 100.0,
              patient_responsibility: 100.0,
            },
          ],
          subtotal: 280.0,
          total_amount: 280.0,
          patient_total: 280.0,
          payment_status: "paid",
          due_date: format(sub(now, { months: 2 }), "yyyy-MM-dd"),
          created_date:
            format(sub(now, { months: 3 }), "yyyy-MM-dd") + "T13:00:00Z",
          created_by: "dr.johnson@example.com",
        },
        {
          id: "b6",
          patient_id: "PAT002",
          billing_date: format(sub(now, { months: 3 }), "yyyy-MM-dd"),
          service_date: format(sub(now, { months: 3 }), "yyyy-MM-dd"),
          provider_name: "Dr. Williams",
          billing_items: [
            {
              item_type: "service",
              description: "NAD+ IV Therapy",
              quantity: 1,
              unit_price: 450.0,
              total_price: 450.0,
              patient_responsibility: 450.0,
            },
          ],
          subtotal: 450.0,
          total_amount: 450.0,
          patient_total: 450.0,
          payment_status: "paid",
          due_date: format(sub(now, { months: 2 }), "yyyy-MM-dd"),
          created_date:
            format(sub(now, { months: 3 }), "yyyy-MM-dd") + "T15:30:00Z",
          created_by: "dr.williams@example.com",
        },
        {
          id: "b7",
          patient_id: "PAT001",
          billing_date: format(sub(now, { months: 2 }), "yyyy-MM-dd"),
          service_date: format(sub(now, { months: 2 }), "yyyy-MM-dd"),
          provider_name: "Dr. Smith",
          billing_items: [
            {
              item_type: "service",
              description: "Comprehensive Health Assessment",
              quantity: 1,
              unit_price: 380.0,
              total_price: 380.0,
              patient_responsibility: 380.0,
            },
            {
              item_type: "supply",
              description: "Supplement Package",
              quantity: 2,
              unit_price: 65.0,
              total_price: 130.0,
              patient_responsibility: 130.0,
            },
          ],
          subtotal: 510.0,
          total_amount: 510.0,
          patient_total: 510.0,
          payment_status: "paid",
          due_date: format(sub(now, { months: 1 }), "yyyy-MM-dd"),
          created_date:
            format(sub(now, { months: 2 }), "yyyy-MM-dd") + "T10:15:00Z",
          created_by: "dr.smith@example.com",
        },
        {
          id: "b8",
          patient_id: "PAT002",
          billing_date: format(sub(now, { months: 2 }), "yyyy-MM-dd"),
          service_date: format(sub(now, { months: 2 }), "yyyy-MM-dd"),
          provider_name: "Dr. Johnson",
          billing_items: [
            {
              item_type: "consultation",
              description: "Hormonal Health Consultation",
              quantity: 1,
              unit_price: 220.0,
              total_price: 220.0,
              patient_responsibility: 220.0,
            },
          ],
          subtotal: 220.0,
          total_amount: 220.0,
          patient_total: 220.0,
          payment_status: "paid",
          due_date: format(sub(now, { months: 1 }), "yyyy-MM-dd"),
          created_date:
            format(sub(now, { months: 2 }), "yyyy-MM-dd") + "T16:00:00Z",
          created_by: "dr.johnson@example.com",
        },
        {
          id: "b9",
          patient_id: "PAT001",
          billing_date: format(sub(now, { months: 1 }), "yyyy-MM-dd"),
          service_date: format(sub(now, { months: 1 }), "yyyy-MM-dd"),
          provider_name: "Dr. Williams",
          billing_items: [
            {
              item_type: "service",
              description: "Detox Therapy Session",
              quantity: 1,
              unit_price: 275.0,
              total_price: 275.0,
              patient_responsibility: 275.0,
            },
            {
              item_type: "lab_test",
              description: "Follow-up Lab Panel",
              quantity: 1,
              unit_price: 120.0,
              total_price: 120.0,
              patient_responsibility: 120.0,
            },
          ],
          subtotal: 395.0,
          total_amount: 395.0,
          patient_total: 395.0,
          payment_status: "paid",
          due_date: format(now, "yyyy-MM-dd"),
          created_date:
            format(sub(now, { months: 1 }), "yyyy-MM-dd") + "T12:30:00Z",
          created_by: "dr.williams@example.com",
        },
        {
          id: "b10",
          patient_id: "PAT002",
          billing_date: format(sub(now, { months: 1 }), "yyyy-MM-dd"),
          service_date: format(sub(now, { months: 1 }), "yyyy-MM-dd"),
          provider_name: "Dr. Smith",
          billing_items: [
            {
              item_type: "service",
              description: "IV Glutathione Therapy",
              quantity: 1,
              unit_price: 185.0,
              total_price: 185.0,
              patient_responsibility: 185.0,
            },
          ],
          subtotal: 185.0,
          total_amount: 185.0,
          patient_total: 185.0,
          payment_status: "pending",
          due_date: format(sub(now, { days: -15 }), "yyyy-MM-dd"),
          created_date:
            format(sub(now, { months: 1 }), "yyyy-MM-dd") + "T14:45:00Z",
          created_by: "dr.smith@example.com",
        },
        {
          id: "b11",
          patient_id: "PAT001",
          billing_date: format(sub(now, { days: 15 }), "yyyy-MM-dd"),
          service_date: format(sub(now, { days: 15 }), "yyyy-MM-dd"),
          provider_name: "Dr. Johnson",
          billing_items: [
            {
              item_type: "consultation",
              description: "Monthly Progress Review",
              quantity: 1,
              unit_price: 150.0,
              total_price: 150.0,
              patient_responsibility: 150.0,
            },
            {
              item_type: "medication",
              description: "Prescription Refill",
              quantity: 2,
              unit_price: 30.0,
              total_price: 60.0,
              patient_responsibility: 60.0,
            },
          ],
          subtotal: 210.0,
          total_amount: 210.0,
          patient_total: 210.0,
          payment_status: "pending",
          due_date: format(sub(now, { days: -10 }), "yyyy-MM-dd"),
          created_date:
            format(sub(now, { days: 15 }), "yyyy-MM-dd") + "T11:00:00Z",
          created_by: "dr.johnson@example.com",
        },
      ],
      wearableData: [
        {
          id: "w1",
          patient_id: "PAT001",
          device_type: "apple_watch",
          date: format(sub(now, { days: 30 }), "yyyy-MM-dd"),
          metrics: {
            steps: 8500,
            heart_rate_avg: 72,
            heart_rate_max: 145,
            sleep_hours: 7.5,
            calories_burned: 2200,
            active_minutes: 45,
            resting_heart_rate: 65,
          },
          created_date: format(sub(now, { days: 30 }), "yyyy-MM-dd") + "T23:59:59Z",
          created_by: "system@example.com",
        },
        {
          id: "w2",
          patient_id: "PAT001",
          device_type: "apple_watch",
          date: format(sub(now, { days: 29 }), "yyyy-MM-dd"),
          metrics: {
            steps: 12000,
            heart_rate_avg: 75,
            heart_rate_max: 150,
            sleep_hours: 8.0,
            calories_burned: 2400,
            active_minutes: 60,
            resting_heart_rate: 63,
          },
          created_date: format(sub(now, { days: 29 }), "yyyy-MM-dd") + "T23:59:59Z",
          created_by: "system@example.com",
        },
        {
          id: "w3",
          patient_id: "PAT001",
          device_type: "apple_watch",
          date: format(sub(now, { days: 28 }), "yyyy-MM-dd"),
          metrics: {
            steps: 9800,
            heart_rate_avg: 70,
            heart_rate_max: 142,
            sleep_hours: 7.2,
            calories_burned: 2150,
            active_minutes: 38,
            resting_heart_rate: 66,
          },
          created_date: format(sub(now, { days: 28 }), "yyyy-MM-dd") + "T23:59:59Z",
          created_by: "system@example.com",
        },
        {
          id: "w4",
          patient_id: "PAT001",
          device_type: "apple_watch",
          date: format(sub(now, { days: 7 }), "yyyy-MM-dd"),
          metrics: {
            steps: 11200,
            heart_rate_avg: 73,
            heart_rate_max: 148,
            sleep_hours: 8.2,
            calories_burned: 2350,
            active_minutes: 55,
            resting_heart_rate: 62,
          },
          created_date: format(sub(now, { days: 7 }), "yyyy-MM-dd") + "T23:59:59Z",
          created_by: "system@example.com",
        },
        {
          id: "w5",
          patient_id: "PAT001",
          device_type: "apple_watch",
          date: format(sub(now, { days: 1 }), "yyyy-MM-dd"),
          metrics: {
            steps: 10500,
            heart_rate_avg: 71,
            heart_rate_max: 144,
            sleep_hours: 7.8,
            calories_burned: 2280,
            active_minutes: 48,
            resting_heart_rate: 64,
          },
          created_date: format(sub(now, { days: 1 }), "yyyy-MM-dd") + "T23:59:59Z",
          created_by: "system@example.com",
        },
        {
          id: "w6",
          patient_id: "PAT002",
          device_type: "fitbit",
          date: format(sub(now, { days: 15 }), "yyyy-MM-dd"),
          metrics: {
            steps: 7200,
            heart_rate_avg: 78,
            heart_rate_max: 155,
            sleep_hours: 6.5,
            calories_burned: 1950,
            active_minutes: 32,
            resting_heart_rate: 70,
          },
          created_date: format(sub(now, { days: 15 }), "yyyy-MM-dd") + "T23:59:59Z",
          created_by: "system@example.com",
        },
        {
          id: "w7",
          patient_id: "PAT002",
          device_type: "fitbit",
          date: format(sub(now, { days: 5 }), "yyyy-MM-dd"),
          metrics: {
            steps: 8900,
            heart_rate_avg: 76,
            heart_rate_max: 152,
            sleep_hours: 7.1,
            calories_burned: 2100,
            active_minutes: 42,
            resting_heart_rate: 68,
          },
          created_date: format(sub(now, { days: 5 }), "yyyy-MM-dd") + "T23:59:59Z",
          created_by: "system@example.com",
        },
        {
          id: "w8",
          patient_id: "PAT003",
          device_type: "garmin",
          date: format(sub(now, { days: 10 }), "yyyy-MM-dd"),
          metrics: {
            steps: 13500,
            heart_rate_avg: 68,
            heart_rate_max: 165,
            sleep_hours: 8.5,
            calories_burned: 2650,
            active_minutes: 75,
            resting_heart_rate: 58,
          },
          created_date: format(sub(now, { days: 10 }), "yyyy-MM-dd") + "T23:59:59Z",
          created_by: "system@example.com",
        },
        {
          id: "w9",
          patient_id: "PAT003",
          device_type: "garmin",
          date: format(sub(now, { days: 2 }), "yyyy-MM-dd"),
          metrics: {
            steps: 14200,
            heart_rate_avg: 67,
            heart_rate_max: 168,
            sleep_hours: 8.3,
            calories_burned: 2720,
            active_minutes: 82,
            resting_heart_rate: 57,
          },
          created_date: format(sub(now, { days: 2 }), "yyyy-MM-dd") + "T23:59:59Z",
          created_by: "system@example.com",
        },
      ],
      biologicalAge: [
        {
          id: "ba1",
          patient_id: "PAT001",
          assessment_date: "2024-01-15",
          chronological_age: 44,
          calculated_biological_age: 42.5,
          age_acceleration: -1.5,
          overall_assessment: {
            longevity_score: 78,
            strengths: [
              "Excellent cognitive function",
              "Strong pulmonary performance",
              "Good NAD+/NADH Ratio",
            ],
            risk_factors: [
              "Elevated visceral fat",
              "Suboptimal immune cell ratio (CD4/CD8)",
              "Slightly high central systolic BP",
            ],
            recommendations: [
              "Incorporate strength training 2x/week to improve body composition.",
              "Increase intake of fiber and polyphenols to support immune health.",
              "Practice stress management techniques like meditation to lower central BP.",
              "Consider a Quercetin supplement to help manage senescent cells.",
              "Re-assess key biomarkers in 6 months.",
            ],
          },
          vascular_age: { score: 82 },
          epigenetic_cellular_age: { score: 75 },
          pulmonary_age: { score: 92 },
          immune_age: { score: 70 },
          blood_phenotypic_age: { score: 88 },
          hormonal_profile: { score: 81 },
          body_composition_metabolic: { score: 68 },
          physical_function: { score: 85 },
          cognitive_neurological: { score: 95 },
          skin_optical_aging: { score: 79 },
          toxicity_oxidative_stress: { score: 88 },
          created_date: "2024-01-15T10:00:00Z",
          created_by: "system@example.com",
        },
        {
          id: "ba2",
          patient_id: "PAT002",
          assessment_date: "2024-02-20",
          chronological_age: 49,
          calculated_biological_age: 52.0,
          age_acceleration: 3.0,
          overall_assessment: {
            longevity_score: 65,
            strengths: ["Strong grip strength", "Healthy liver enzymes"],
            risk_factors: [
              "High HbA1c (pre-diabetic range)",
              "Elevated C-Reactive Protein (Inflammation)",
              "Low VO2 Max",
            ],
            recommendations: [
              "Focus on a low-glycemic diet to manage blood sugar.",
              "Incorporate regular cardiovascular exercise (3-4x/week).",
              "Add anti-inflammatory foods like turmeric and ginger to diet.",
              "Discuss metformin with your physician as a preventative measure.",
            ],
          },
          vascular_age: { score: 70 },
          epigenetic_cellular_age: { score: 68 },
          pulmonary_age: { score: 80 },
          immune_age: { score: 65 },
          blood_phenotypic_age: { score: 62 },
          hormonal_profile: { score: 75 },
          body_composition_metabolic: { score: 72 },
          physical_function: { score: 78 },
          cognitive_neurological: { score: 85 },
          skin_optical_aging: { score: 75 },
          toxicity_oxidative_stress: { score: 80 },
          created_date: "2024-02-20T10:00:00Z",
          created_by: "system@example.com",
        },
      ],
      users: [
        {
          id: "u1",
          full_name: "Dr. Sarah Johnson",
          email: "sarah.johnson@healthtracker.com",
          role: "admin",
          created_date: "2024-01-01T00:00:00Z",
        },
        {
          id: "u2",
          full_name: "Dr. Mark Williams",
          email: "mark.williams@healthtracker.com",
          role: "user",
          created_date: "2024-01-02T00:00:00Z",
        },
      ],
      conciergeRequests: [
        {
          id: "cr1",
          patient_name: "John Doe",
          patient_dob: "1980-05-15",
          patient_address: "123 Main St, Anytown, USA",
          patient_phone: "555-123-4567",
          patient_email: "john.doe@example.com",
          referring_doctor: "Smith",
          requested_tests: ["Complete Blood Count (CBC)", "Lipid Panel"],
          preferred_date: "2024-07-20",
          preferred_time_slot: "morning",
          clinical_notes:
            "Routine follow-up for hypertension. Patient reports occasional dizziness when standing.",
          status: "submitted",
          created_date: "2024-07-15T09:00:00Z",
          created_by: "dr.smith@example.com",
        },
        {
          id: "cr2",
          patient_name: "Jane Smith",
          patient_dob: "1975-08-22",
          patient_address: "456 Oak Ave, Anytown, USA",
          patient_phone: "555-987-6543",
          patient_email: "jane.smith@example.com",
          referring_doctor: "Williams",
          requested_tests: [
            "Thyroid Panel (TSH, T3, T4)",
            "Vitamin D, 25-Hydroxy",
          ],
          preferred_date: "2024-07-22",
          preferred_time_slot: "afternoon",
          clinical_notes:
            "Patient presents with fatigue, weight gain, and cold intolerance. Family history of thyroid disorders. Suspect hypothyroidism.",
          status: "scheduled",
          assigned_nurse: "Nurse Jackie",
          scheduled_visit_datetime: "2024-07-22T14:30:00Z",
          created_date: "2024-07-16T11:00:00Z",
          created_by: "dr.williams@example.com",
        },
        {
          id: "cr3",
          patient_name: "Robert Johnson",
          patient_dob: "1965-12-10",
          patient_address: "789 Pine Street, Anytown, USA",
          patient_phone: "555-456-7890",
          patient_email: "robert.johnson@example.com",
          referring_doctor: "Martinez",
          requested_tests: [
            "Male Hormone Profile (Testosterone Total & Free, DHEA-S, Estradiol)",
            "PSA (Prostate Specific Antigen)",
            "Complete Blood Count (CBC)",
          ],
          preferred_date: "2024-07-25",
          preferred_time_slot: "morning",
          clinical_notes:
            "Male patient, 58 years old, complaining of decreased energy, reduced libido, and difficulty concentrating over the past 6 months. No significant past medical history. Requesting hormone evaluation to rule out hypogonadism.",
          status: "completed",
          assigned_nurse: "Nurse Patricia",
          scheduled_visit_datetime: "2024-07-25T09:00:00Z",
          created_date: "2024-07-18T14:30:00Z",
          created_by: "dr.martinez@example.com",
        },
      ],
      onlineBookings: [],
      clinicProfiles: [],
      appSettings: [],
      rooms: [
        {
          id: "r1",
          room_number: "101",
          room_name: "IV Therapy Suite A",
          room_type: "iv_therapy",
          capacity: 2,
          floor: "1st Floor",
          description: "Primary IV therapy room with reclining chairs",
          status: "active",
          equipment_ids: ["e1", "e2", "e3"],
          created_date: "2024-01-01T00:00:00Z",
          created_by: "admin@example.com",
        },
        {
          id: "r2",
          room_number: "102",
          room_name: "Consultation Room",
          room_type: "consultation",
          capacity: 4,
          floor: "1st Floor",
          description: "Primary consultation and examination room",
          status: "active",
          equipment_ids: ["e4", "e5"],
          created_date: "2024-01-01T00:00:00Z",
          created_by: "admin@example.com",
        },
        {
          id: "r3",
          room_number: "103",
          room_name: "Procedure Room",
          room_type: "procedure",
          capacity: 3,
          floor: "1st Floor",
          description: "Room for minor procedures and blood draws",
          status: "active",
          equipment_ids: ["e6", "e7"],
          created_date: "2024-01-01T00:00:00Z",
          created_by: "admin@example.com",
        },
      ],

      equipment: [
        {
          id: "e1",
          equipment_name: "IV Infusion Pump Model A",
          equipment_code: "IVP-001",
          category: "iv_equipment",
          manufacturer: "MedTech Inc",
          model: "Infusion Pro 2000",
          serial_number: "IVP2000-12345",
          purchase_date: "2023-06-15",
          warranty_expiry: "2026-06-15",
          maintenance_schedule: "quarterly",
          last_maintenance: "2024-01-15",
          status: "active",
          assigned_room_id: "r1",
          notes: "Primary infusion pump for room 101",
          created_date: "2023-06-15T00:00:00Z",
          created_by: "admin@example.com",
        },
        {
          id: "e2",
          equipment_name: "Patient Monitor",
          equipment_code: "MON-001",
          category: "monitoring",
          manufacturer: "VitalSigns Corp",
          model: "VS-Monitor 500",
          serial_number: "VSM500-67890",
          purchase_date: "2023-08-10",
          warranty_expiry: "2026-08-10",
          maintenance_schedule: "bi-annual",
          last_maintenance: "2024-02-01",
          status: "active",
          assigned_room_id: "r1",
          notes: "Continuous patient monitoring during IV therapy",
          created_date: "2023-08-10T00:00:00Z",
          created_by: "admin@example.com",
        },
        {
          id: "e3",
          equipment_name: "Reclining Chair - Patient A",
          equipment_code: "CHR-001",
          category: "furniture",
          manufacturer: "ComfortCare",
          model: "Therapy Lounger Deluxe",
          serial_number: "TLD-001",
          purchase_date: "2023-05-20",
          warranty_expiry: "2028-05-20",
          maintenance_schedule: "annual",
          last_maintenance: "2024-01-10",
          status: "active",
          assigned_room_id: "r1",
          notes: "Primary patient chair for IV therapy",
          created_date: "2023-05-20T00:00:00Z",
          created_by: "admin@example.com",
        },
        {
          id: "e4",
          equipment_name: "Blood Pressure Monitor",
          equipment_code: "BPM-001",
          category: "diagnostic",
          manufacturer: "HealthCheck Systems",
          model: "AutoBP Pro",
          serial_number: "ABP-11223",
          purchase_date: "2023-07-05",
          warranty_expiry: "2026-07-05",
          maintenance_schedule: "annual",
          last_maintenance: "2024-01-20",
          status: "active",
          assigned_room_id: "r2",
          notes: "Automated blood pressure monitoring",
          created_date: "2023-07-05T00:00:00Z",
          created_by: "admin@example.com",
        },
        {
          id: "e5",
          equipment_name: "Examination Table",
          equipment_code: "EXT-001",
          category: "furniture",
          manufacturer: "MedFurniture Co",
          model: "Exam Pro 300",
          serial_number: "EP300-445566",
          purchase_date: "2023-04-15",
          warranty_expiry: "2028-04-15",
          maintenance_schedule: "bi-annual",
          last_maintenance: "2024-01-25",
          status: "active",
          assigned_room_id: "r2",
          notes: "Height-adjustable examination table",
          created_date: "2023-04-15T00:00:00Z",
          created_by: "admin@example.com",
        },
        {
          id: "e6",
          equipment_name: "Phlebotomy Chair",
          equipment_code: "PHC-001",
          category: "furniture",
          manufacturer: "BloodDraw Systems",
          model: "Phlebotomy Comfort",
          serial_number: "PC-778899",
          purchase_date: "2023-09-10",
          warranty_expiry: "2028-09-10",
          maintenance_schedule: "annual",
          last_maintenance: "2024-02-05",
          status: "active",
          assigned_room_id: "r3",
          notes: "Specialized chair for blood draws",
          created_date: "2023-09-10T00:00:00Z",
          created_by: "admin@example.com",
        },
        {
          id: "e7",
          equipment_name: "Centrifuge",
          equipment_code: "CEN-001",
          category: "diagnostic",
          manufacturer: "LabTech Solutions",
          model: "SpinMaster 1000",
          serial_number: "SM1000-334455",
          purchase_date: "2023-10-20",
          warranty_expiry: "2026-10-20",
          maintenance_schedule: "quarterly",
          last_maintenance: "2024-01-30",
          status: "active",
          assigned_room_id: "r3",
          notes: "For blood sample processing",
          created_date: "2023-10-20T00:00:00Z",
          created_by: "admin@example.com",
        },
      ],
    };

    this.idCounters = {
      bloodTests: 15,
      clinicalNotes: 3,
      prescriptions: 2,
      stockItems: 3,
      stockTransactions: 2,
      services: 3,
      serviceAppointments: 11,
      unavailability: 3, // New idCounter for unavailability
      patients: 4,
      billings: 12,
      wearableData: 10,
      biologicalAge: 3,
      users: 3,
      conciergeRequests: 4, // Incremented due to new 'cr3'
      onlineBookings: 1,
      clinicProfiles: 1,
      appSettings: 1,
      rooms: 4,
      equipment: 8,
    };
  }

  // Generic CRUD operations
  list(entityName, sortField = null, limit = null) {
    // Ensure entityName is a string
    if (typeof entityName !== "string") {
      console.error(
        `MockDataStore Error: Entity name must be a string, received:`,
        entityName
      );
      return Promise.resolve([]);
    }

    if (!this.data[entityName]) {
      console.error(
        `MockDataStore Error: Entity "${entityName}" does not exist.`
      );
      return Promise.resolve([]);
    }

    let data = [...this.data[entityName]];

    if (sortField) {
      const isDescending = sortField.startsWith("-");
      const field = isDescending ? sortField.slice(1) : sortField;

      data.sort((a, b) => {
        try {
          const aVal = this.getNestedValue(a, field);
          const bVal = this.getNestedValue(b, field);

          if (aVal < bVal) return isDescending ? 1 : -1;
          if (aVal > bVal) return isDescending ? -1 : 1;
          return 0;
        } catch (error) {
          console.error("Error sorting data:", error);
          return 0;
        }
      });
    }

    if (limit && typeof limit === "number") {
      data = data.slice(0, limit);
    }

    return Promise.resolve(data);
  }

  filter(entityName, filterObj, sortField = null, limit = null) {
    // Ensure entityName is a string
    if (typeof entityName !== "string") {
      console.error(
        `MockDataStore Error: Entity name must be a string, received:`,
        entityName
      );
      return Promise.resolve([]);
    }

    if (!this.data[entityName]) {
      console.error(
        `MockDataStore Error: Entity "${entityName}" does not exist.`
      );
      return Promise.resolve([]);
    }

    if (!filterObj || typeof filterObj !== "object") {
      return this.list(entityName, sortField, limit);
    }

    let data = this.data[entityName].filter((item) => {
      try {
        return Object.entries(filterObj).every(([key, value]) => {
          return this.getNestedValue(item, key) === value;
        });
      } catch (error) {
        console.error("Error filtering data:", error);
        return false;
      }
    });

    if (sortField) {
      const isDescending = sortField.startsWith("-");
      const field = isDescending ? sortField.slice(1) : sortField;

      data.sort((a, b) => {
        try {
          const aVal = this.getNestedValue(a, field);
          const bVal = this.getNestedValue(b, field);

          if (aVal < bVal) return isDescending ? 1 : -1;
          if (aVal > bVal) return isDescending ? -1 : 1;
          return 0;
        } catch (error) {
          console.error("Error sorting filtered data:", error);
          return 0;
        }
      });
    }

    if (limit && typeof limit === "number") {
      data = data.slice(0, limit);
    }

    return Promise.resolve(data);
  }

  create(entityName, data) {
    // Ensure entityName is a string
    if (typeof entityName !== "string") {
      console.error(
        `MockDataStore Error: Entity name must be a string, received:`,
        entityName
      );
      return Promise.reject(new Error(`Entity name must be a string`));
    }

    if (!this.data[entityName]) {
      console.error(
        `MockDataStore Error: Cannot create in non-existent entity "${entityName}".`
      );
      return Promise.reject(
        new Error(`Entity "${entityName}" does not exist.`)
      );
    }
    const newId = `${entityName.slice(0, 2)}${this.idCounters[entityName]}`;
    this.idCounters[entityName]++;

    const newItem = {
      id: newId,
      ...data,
      created_date: new Date().toISOString(),
      created_by: "system@example.com",
    };

    this.data[entityName].push(newItem);
    return Promise.resolve(newItem);
  }

  bulkCreate(entityName, dataArray) {
    // Ensure entityName is a string
    if (typeof entityName !== "string") {
      console.error(
        `MockDataStore Error: Entity name must be a string, received:`,
        entityName
      );
      return Promise.reject(new Error(`Entity name must be a string`));
    }

    if (!this.data[entityName]) {
      console.error(
        `MockDataStore Error: Cannot bulk create in non-existent entity "${entityName}".`
      );
      return Promise.reject(
        new Error(`Entity "${entityName}" does not exist.`)
      );
    }
    const newItems = dataArray.map((data) => {
      const newId = `${entityName.slice(0, 2)}${this.idCounters[entityName]}`;
      this.idCounters[entityName]++;

      return {
        id: newId,
        ...data,
        created_date: new Date().toISOString(),
        created_by: "system@example.com",
      };
    });

    this.data[entityName].push(...newItems);
    return Promise.resolve(newItems);
  }

  update(entityName, id, data) {
    // Ensure entityName is a string
    if (typeof entityName !== "string") {
      console.error(
        `MockDataStore Error: Entity name must be a string, received:`,
        entityName
      );
      return Promise.reject(new Error(`Entity name must be a string`));
    }

    if (!this.data[entityName]) {
      console.error(
        `MockDataStore Error: Cannot update in non-existent entity "${entityName}".`
      );
      return Promise.reject(
        new Error(`Entity "${entityName}" does not exist.`)
      );
    }
    const index = this.data[entityName].findIndex((item) => item.id === id);
    if (index !== -1) {
      this.data[entityName][index] = {
        ...this.data[entityName][index],
        ...data,
        updated_date: new Date().toISOString(),
      };
      return Promise.resolve(this.data[entityName][index]);
    }
    return Promise.reject(new Error("Item not found"));
  }

  delete(entityName, id) {
    // Ensure entityName is a string
    if (typeof entityName !== "string") {
      console.error(
        `MockDataStore Error: Entity name must be a string, received:`,
        entityName
      );
      return Promise.reject(new Error(`Entity name must be a string`));
    }

    if (!this.data[entityName]) {
      console.error(
        `MockDataStore Error: Cannot delete from non-existent entity "${entityName}".`
      );
      return Promise.reject(
        new Error(`Entity "${entityName}" does not exist.`)
      );
    }
    const index = this.data[entityName].findIndex((item) => item.id === id);
    if (index !== -1) {
      this.data[entityName].splice(index, 1);
      return Promise.resolve(true);
    }
    return Promise.reject(new Error("Item not found"));
  }

  getNestedValue(obj, path) {
    try {
      if (!obj || typeof obj !== "object" || obj === null || !path)
        return undefined;
      return path.split(".").reduce((o, key) => o && o[key], obj);
    } catch (error) {
      console.error("Error getting nested value:", error);
      return undefined;
    }
  }

  // User-specific methods
  me() {
    return Promise.resolve(this.data.users[0]);
  }

  logout() {
    return Promise.resolve();
  }

  login() {
    return Promise.resolve();
  }

  updateMyUserData(data) {
    this.data.users[0] = { ...this.data.users[0], ...data };
    return Promise.resolve(this.data.users[0]);
  }

  // Schema methods (can be expanded if needed)
  getSchema(entityName) {
    // This is a simplified mock. In a real app, schemas might be more complex.
    const schemas = {
      bloodTests: {
        type: "object",
        properties: {
          test_date: { type: "string", format: "date" },
          test_type: { type: "string" },
          lab_name: { type: "string" },
          doctor_name: { type: "string" },
          results: { type: "object" },
          notes: { type: "string" },
          patient_id: { type: "string" },
        },
      },
    };
    return Promise.resolve(schemas[entityName] || {});
  }
}

// Mock integrations to replace any remaining backend calls
export const mockIntegrations = {
  InvokeLLM: async ({ prompt, response_json_schema }) => {
    await new Promise((resolve) => setTimeout(resolve, 1500));

    if (response_json_schema?.properties?.overall_score) {
      return {
        overall_score: 78,
        category_scores: {
          metabolic_health: 85,
          cardiovascular: 72,
          inflammation: 68,
          hormonal_balance: 81,
          nutritional_status: 75,
        },
        strengths: ["Good glucose control", "Optimal vitamin D levels"],
        concerns: [
          "Slightly elevated LDL cholesterol",
          "Signs of moderate inflammation (CRP)",
        ],
        risk_factors: ["Cardiovascular disease risk based on lipid panel"],
        insights:
          "Overall health is good, but focus on improving cardiovascular and inflammation markers is recommended through diet and exercise.",
      };
    }
    if (response_json_schema?.properties?.recommendations) {
      return {
        recommendations: [
          {
            category: "Nutrition",
            title: "Increase Omega-3 Intake",
            description:
              "Consume fatty fish like salmon or mackerel 2-3 times per week.",
            priority: "high",
            timeline: "Ongoing",
          },
          {
            category: "Exercise",
            title: "Incorporate HIIT",
            description:
              "Add 2 sessions of High-Intensity Interval Training per week to improve cardiovascular health.",
            priority: "high",
            timeline: "Next 3 months",
          },
          {
            category: "Lifestyle",
            title: "Prioritize Sleep",
            description:
              "Aim for 7-8 hours of quality sleep per night to manage inflammation.",
            priority: "medium",
            timeline: "Ongoing",
          },
          {
            category: "Supplementation",
            title: "Consider CoQ10",
            description:
              "Discuss with your provider about adding a CoQ10 supplement for heart health.",
            priority: "low",
            timeline: "Next check-up",
          },
          {
            category: "Follow-up",
            title: "Re-check Lipids",
            description:
              "Schedule a follow-up lipid panel in 3-6 months to monitor progress.",
            priority: "high",
            timeline: "3-6 months",
          },
        ],
      };
    }
    return {
      calculated_biological_age: 42.5,
      age_acceleration: -1.5,
      domain_scores: {
        vascular: 85,
        epigenetic: 78,
        pulmonary: 92,
        immune: 75,
        blood_phenotypic: 88,
        hormonal: 81,
        body_composition: 70,
        physical_function: 85,
        cognitive: 90,
        skin_optical: 82,
        toxicity: 88,
      },
      longevity_score: 78,
      risk_factors: ["Elevated visceral fat", "Suboptimal immune cell ratio"],
      strengths: [
        "Excellent cognitive function",
        "Strong pulmonary performance",
      ],
      recommendations: [
        "Increase fiber intake",
        "Incorporate strength training 2x/week",
        "Optimize sleep schedule",
      ],
    };
  },

  SendEmail: async (params) => {
    await new Promise((resolve) => setTimeout(resolve, 500));
    return { success: true };
  },

  GenerateImage: async ({ prompt }) => {
    await new Promise((resolve) => setTimeout(resolve, 3000));
    return {
      url: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=500",
    };
  },

  UploadFile: async ({ file }) => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    return { file_url: `mock://uploads/${file.name}` };
  },

  ExtractDataFromUploadedFile: async ({ file_url }) => {
    await new Promise((resolve) => setTimeout(resolve, 2000));
    return {
      status: "success",
      details: null,
      output: [
        {
          glucose: 95,
          cholesterol_total: 185,
          hemoglobin: 14.2,
        },
      ],
    };
  },
};

export const mockDataStore = new MockDataStore();
